<template>
  <v-container fluid>
    <v-layout column>
        <v-flex xs12>
          <h2 class=".display-1" dark>Mitarbeiter</h2>
        </v-flex>
        <v-flex xs12>
          <v-layout row>
            <v-text-field
              v-model="searchTerm"
              class="mx-1" label="Suche nach Vornamen"
              prepend-inner-icon="search"
              solo
              clearable
            ></v-text-field>
            <v-btn dark
                   class="hidden-md-and-up"
                   @click="openNewUserDialog"
                   color="primary">
              <v-icon dark>person_add</v-icon>
            </v-btn>
            <v-btn depressed
                   medium
                   dark
                   class="hidden-sm-and-down"
                   @click="openNewUserDialog"
                   color="primary">
              Mitarbeiter Anlegen
              <v-icon right dark>person_add</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
    </v-layout>
    <v-layout row fill-height>
        <v-flex>
          <v-list
            id="userList"
            two-line
            style="max-height: calc(100vh - 190px)"
            class="overflow-y-auto">
            <v-flex
              v-scroll:#userList="onScroll"
              align="center"
              justify="center"
            >
              <template v-for="(user,index) in users">
                <v-list-item v-if="index % 2 === 1" :key="index" style="background-color: #B3E5FC40">
                  <v-list-item-action>
                    <v-icon v-if="user.role.name==='ADMIN'">school</v-icon>
                    <v-icon v-else>person</v-icon>
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title>{{user.email}}</v-list-item-title>
                    <v-list-item-subtitle>{{user.firstName}} {{user.lastName}}</v-list-item-subtitle>
                    <v-list-item-subtitle>Kunden: {{user.customers.length}}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action
                    v-if="user.id > 1">
                    <v-btn text
                           icon
                           @click="openEditUser(user)"
                           color="primary">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-action
                    v-if="user.id > 1">
                    <v-btn text
                           icon
                           @click="openDeleteUser(user)"
                           color="primary">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item v-else :key="index">
                  <v-list-item-action>
                    <v-icon v-if="user.role.name==='ADMIN'">school</v-icon>
                    <v-icon v-else>person</v-icon>
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title>{{user.email}}</v-list-item-title>
                    <v-list-item-subtitle>{{user.firstName}} {{user.lastName}}</v-list-item-subtitle>
                    <v-list-item-subtitle>Kunden: {{user.customers.length}}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action
                    v-if="user.id > 1">
                    <v-btn text
                           icon
                           @click="openEditUser(user)"
                           color="primary">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-action
                    v-if="user.id > 1">
                    <v-btn text
                           icon
                           @click="openDeleteUser(user)"
                           color="primary">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider
                  v-if="index + 1 < users.length"
                  :key="'divider-'+index"
                ></v-divider>
              </template>
            </v-flex>
          </v-list>
          <new-user-dialog :show="showNewUserDialog" @close="closeNewUserDialog"></new-user-dialog>
          <edit-user-dialog :user="selectedUser" :show="showEditUserDialog"
                            @close="closeEditUserDialog"></edit-user-dialog>
          <delete-user-dialog :user="selectedUser" :show="showDeleteUserConfirmDialog"
                              @close="closeDeleteUserDialog"></delete-user-dialog>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import _ from 'lodash'
  import newUserDialog from './NewUserDialog'
  import editUserDialog from './EditUserDialog'
  import deleteUserConfirmDialog from './DeleteUserConfirmDialog'

  export default {
    name: 'UserManagement',
    data () {
      return {
        searchTerm: '',
        page: 0,
        size: 50,
        bottom: false,
        showNewUserDialog: false,
        showEditUserDialog: false,
        showDeleteUserConfirmDialog: false,
        selectedUser: {
          email: '',
          role: null,
          customers: [],
          firstName: '',
          lastName: '',
          street: '',
          zipCode: '',
          city: ''
        }
      }
    },
    components: {
      'new-user-dialog': newUserDialog,
      'edit-user-dialog': editUserDialog,
      'delete-user-dialog': deleteUserConfirmDialog
    },
    computed: {
      users: function () {
        return this.$store.getters.allUsers
      },
      maxUsers: function () {
        return this.$store.getters.maxUsers
      }
    },
    watch: {
      bottom (bottom) {
        if (bottom && this.users.length < this.maxUsers) {
          this.page++
          this.searchUsers(this.searchTerm)
        }
      },
      searchTerm (searchTerm) {
        this.page = 0
        this.$store.dispatch('resetUsers')
        if (searchTerm === null) {
          this.searchTerm = ''
          this.searchUsers(this.searchTerm)
        } else {
          this.debouncedSearchUsers(this.searchTerm)
        }
      }
    },
    created () {
      this.debouncedSearchUsers = _.debounce(this.searchUsers, 500)

      this.$store.dispatch('loadRoles')
      this.$store.dispatch('resetCustomers')
      this.$store.dispatch('loadCustomers', {
        searchTerms: [],
        page: this.page,
        size: this.size
      })

      this.$store.dispatch('resetUsers')
      this.searchUsers(this.searchTerm)
    },
    methods: {
      searchUsers: function (searchTerm) {
        this.$store.dispatch('loadUsers',
          {
            searchTerms: searchTerm.split(' '),
            page: this.page,
            size: this.size
          })
      },
      onScroll: function (e) {
        const scrollY = e.target.scrollTop
        const visible = e.target.clientHeight
        const pageHeight = e.target.scrollHeight - 64.0 // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
        const bottomOfPage = visible + scrollY >= pageHeight
        this.bottom = bottomOfPage || pageHeight < visible
      },
      openEditUser: function (user) {
        this.selectedUser = user
        this.showEditUserDialog = true
      },
      openNewUserDialog: function () {
        this.showNewUserDialog = true
      },
      closeNewUserDialog: function () {
        this.showNewUserDialog = false
        // this.resetSearch()
      },
      closeEditUserDialog: function () {
        this.showEditUserDialog = false
        // this.resetSearch()
      },
      openDeleteUser: function (user) {
        this.selectedUser = {
          id: user.id,
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
          role: user.role,
          customers: user.customers,
          street: user.street,
          zipCode: user.zipCode,
          city: user.city
        }
        this.showDeleteUserConfirmDialog = true
      },
      closeDeleteUserDialog: function () {
        this.showDeleteUserConfirmDialog = false
        this.resetSearch()
      },
      resetSearch: function () {
        this.searchTerm = ''
        this.searchUsers(this.searchTerm)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Users/UserManagement.vue